<template>
    <div :id="'radio--' + component_id">
        <div v-if="options_loaded && passed_filter && show_laminated_option && panel_required" class="designeroption">
            <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                <span>{{ title }}</span>
                <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + component_id"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionDoorGlassLaminated from "../DesignerQuestionDoorGlassLaminated.vue";
    import RadioQuestion from "../mixin/RadioQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionDoorGlassLaminated,
            RadioQuestion,
        ],
        props: {
            securedByDesign: {
                required: true,
            },
            isFiredoor: {
                required: true,
            },
        },
        methods: {
            get_side(side) {
                if (side == 'top') {
                    if (this.frameStyle.checkedPanels.indexOf("top") !== -1) {
                        return 1;
                    }
                    return 0;
                }
                if (!this.isFiredoor && this.sidePanels[side]) {
                    if (side == 'left' || side == 'right') {
                        if (this.frameStyle.checkedPanels.indexOf(side) !== -1) {
                            return this.sidePanels[side];
                        }
                        return 0;
                    }
                    return this.sidePanels[side];
                }
                return 0;
            }
        },
        computed: {
            filtered_option_list(){
                if (Array.isArray(this.option_list)) {
                    if (this.securedByDesign === 1) {
                        return this.option_list.filter((key) => {
                            return key.value !== null && key.value !== 2;
                        });
                    } else {
                        return this.option_list.filter((key) => {
                            return key.value !== null;
                        });
                    }
                } else {
                    return [];
                }
            },
            url(){
                return '/api/options/' + this.fabricator + '/laminated-glass?secured_by_design=' + this.securedByDesign + '&slab=' + this.slab + '&left=' + this.get_side('left') + '&right=' + this.get_side('right') + '&top=' + this.get_side('top') + '&comp_left=' + this.get_side('left_composite_id') + '&comp_right=' + this.get_side('right_composite_id');
            },
            passed_filter(){
                return this.variable_ready(this.securedByDesign, this.slab, this.frameStyle, this.sidePanels);
            },
            cache_key(){
                return '_' + this.securedByDesign + '_' + this.slab + '_' + this.get_side('left') + '_' + this.get_side('right') + '_' + this.get_side('top') + '_' + this.get_side('left_composite_id') + '_' + this.get_side('right_composite_id');
            },
        },
        mounted() {
            var options = $('#radio--' + this.component_id + ' input').not('.icheck');

            options.addClass('icheck').iCheck({
              checkboxClass: 'checkboxstyle',
              radioClass: 'radiostyle',
              selectClass: 'selectstyle'
          });
        },
        watch: {
            'securedByDesign': function (val, oldVal) {
                this.update_options();
            },
            'isFiredoor': function (val, oldVal) {
                this.update_options();
            }
        }
    }
</script>
